import type { ReactNode } from "react";
import { Logo } from "@/components/logo";

export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className="grid min-h-screen place-items-center bg-background px-6">
      <div className="w-full max-w-sm">
        <Logo className="mx-auto mb-8 h-10" />
        {children}
      </div>
    </div>
  );
}
